module.exports = __webpack_public_path__ + "media/images/like-495931d561b447205abf64de1c0b6dc0.png";